import { getConsumerDataForVehicleName } from '@wkda/funnel-modules';
import { useQuery } from '@tanstack/react-query';
import useCarleadHashParam from '../useCarleadHashParam';
import { useModulesStore } from '../useModules';
import { getVehicleName } from '@wkda/funnel-utils';
export function useGetConsumerCarlead(carleadHash) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    consumerModule
  } = useModulesStore();
  const hash = useCarleadHashParam() || carleadHash;
  return useQuery({
    queryKey: ['consumerCarlead', hash],
    queryFn: () => consumerModule.getConsumerCarlead(hash),
    enabled: Boolean(hash),
    ...options,
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });
}
export function useGetConsumerSelfEvaluation(carleadHash) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    consumerModule
  } = useModulesStore();
  const hash = useCarleadHashParam() || carleadHash;
  return useQuery({
    queryKey: ['consumerSelfEvaluation', hash],
    queryFn: () => consumerModule.getConsumerSelfEvaluation(hash),
    enabled: Boolean(hash),
    retry: false,
    ...options,
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });
}
export function useVehicleNameFromConsumerCarlead() {
  const hash = useCarleadHashParam();
  return useGetConsumerCarlead(hash, {
    select(data) {
      return getVehicleName(getConsumerDataForVehicleName(data));
    }
  });
}
export function useConsumerSourceId() {
  const consumerCarlead = useGetConsumerCarlead();
  return consumerCarlead?.data?.sourceId ? `${consumerCarlead?.data?.sourceId}` : '';
}
export function useConsumerCarleadMarketingProperty(propertyName) {
  const {
    marketingPropertiesModule
  } = useModulesStore();
  const {
    data: consumerCarlead
  } = useGetConsumerCarlead();
  const property = (consumerCarlead?.carMarketingProperties ?? []).find(property => property.propertyId === marketingPropertiesModule.propertyIds[propertyName]);
  return property;
}
export function useConsumerCarleadCarProperty(propertyId) {
  const {
    data: consumerCarlead
  } = useGetConsumerCarlead();
  const property = (consumerCarlead?.carProperties ?? []).find(property => property.propertyId === propertyId);
  return property;
}